import React from 'react';
import { Box, Grid, Spinner } from '@chakra-ui/react';
import { Text } from '~/common/components/defaultUIComponents';
import { HoursByEmployeeChart } from './HoursByEmployeeChart';
import { AvgFactorByProjectChart } from './AvgFactorByProjectChart';
import { WeeklyThroughputChart } from './WeeklyThroughputChart';
import ProjectRecordApi from '~/common/api/zeiterfassungServerApi/ProjectRecordApi';
import { useWeeklyThroughput } from '~/common/api/orderingServiceApi/OrderingApi';
import useTranslate from '~/common/utils/translate';

interface Props {
  start: string;
  end: string;
}

export const GlobalOverview: React.FC<Props> = ({ start, end }) => {
  const t = useTranslate();
  const { data: summary, isLoading: summaryLoading } = ProjectRecordApi.hooks.useGlobalSummary(
    start,
    end,
  );
  const { data: throughput, isLoading: throughputLoading } = useWeeklyThroughput(start, end);

  if (summaryLoading || throughputLoading) return <Spinner />;

  return (
    <Box>
      <Text fontSize="md" fontWeight="600" mb={3}>
        {t('projectRecords.globalOverview')}
      </Text>
      {summary && summary.by_project.length > 0 && (
        <HoursByEmployeeChart data={summary.by_project} />
      )}
      <Grid templateColumns="1fr 1fr" gap={3} mt={3}>
        {summary && summary.by_project.length > 0 && (
          <AvgFactorByProjectChart data={summary.by_project} />
        )}
        {throughput && throughput.length > 0 && <WeeklyThroughputChart data={throughput} />}
      </Grid>
    </Box>
  );
};
